<template>
    <div class="no-result">
        <slot name="img">
            <img src="img/noResult.png">
        </slot>
        <slot></slot>
        <span style="height: 100%;display: inline-block;width: 0px;vertical-align: middle;"></span>
    </div>
</template>
<script>
export default {
}
</script>
<style lang="scss">
@import './noResult.scss';
</style>

